import { HttpClient } from "../../../services/http/http-client";
import { MODIFICATION_URL } from "../../../services/common-urls";
import { BOOKING_URL, BOOKINGS_STRING, CALENDAR_DATES_STRING } from "./booking-service";

// const ADD_NEW_STRING = 'add_new';
// const DELETE_NAME_STRING = 'delete_name';
// const EDIT_STRING = 'edit';
const SECTION_BOOKING_TEMPLATES = 'templates';

export const bookingTemplatesService = {

    getBookingTemplates: () => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_TEMPLATES
        });
    },

    deleteBookingTemplate: (templateId) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_TEMPLATES,
            action: 'remove_template',
            id: templateId
        });
    },

    getBookingTemplate: (templateId) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_TEMPLATES,
            action: 'promoter_rider',
            id: templateId
        });
    },

    addNewBookingTemplate: (defaultValues) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_TEMPLATES,
            action: 'new_template',
            type: defaultValues.type,
            booking_template_name: defaultValues.booking_template_name
        });
    },

    modify: ({ isRecord, name, value, kVal }) => {
        if (isRecord === true) {
            return HttpClient.post(MODIFICATION_URL, {
                modify_type: 'record',
                table: 'booking_templates',
                kVal,
                [name]: value
            });
        } else {
            HttpClient.modify('booking_template_id', kVal, name, value, 'booking_templates');
        }
    }
};
